import ServiceOutageTauron from './ServiceOutageTauron';

export default ServiceOutageTauron;
